import { VueComponent } from "../../../../../types/VueComponent";
import {
  AutoReplyConditionBaseFields,
  AutoReplyConditionTypeEnum,
} from "../../types";
import { ConditionBuilder } from "../ConditionBuilder";

export type StartsWithCondition = { type: AutoReplyConditionTypeEnum.StartsWith } & AutoReplyConditionBaseFields

export class StartsWithBuilder extends ConditionBuilder {
  getModel(): StartsWithCondition {
    return {
      type: AutoReplyConditionTypeEnum.StartsWith,
      values: [],
      invert: false
    }
  }

  type: AutoReplyConditionTypeEnum = AutoReplyConditionTypeEnum.StartsWith;
  view: VueComponent = () => import('./StartsWithSetting.vue');
}

export const StartsWithConditionBuilder = new StartsWithBuilder()
